import script from "./selected-coverages-table.vue?vue&type=script&setup=true&lang=js"
export * from "./selected-coverages-table.vue?vue&type=script&setup=true&lang=js"

import "./selected-coverages-table.vue?vue&type=style&index=0&id=156fefa7&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-156fefa7"]])

export default __exports__